import React, { ComponentPropsWithRef, FC } from 'react';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import classnames from 'classnames';
import dynamic from 'next/dynamic';

import styles from './Footer.module.scss';

const FooterContentMobile: any = dynamic<{}>(
  () => import('./FooterContentMobile.component').then(module => module.FooterContentMobile),
  {
    ssr: false,
  }
);

const FooterContentDesktop: any = dynamic<{}>(
  () => import('./FooterContentDesktop.component').then(module => module.FooterContentDesktop),
  {
    ssr: false,
  }
);

const FooterContent: FC<ComponentPropsWithRef<'div'>> = ({ className, ...rest }) => {
  const rootClassName = classnames(styles.plcFooterContent, 'plc-py-m', 'plc-py-up-s-l', className);
  const isSmartphone = useIsBreakpointDown(Breakpoint.s);
  return (
    <div className={rootClassName} {...rest}>
      {isSmartphone ? <FooterContentMobile /> : <FooterContentDesktop />}
    </div>
  );
};

export default FooterContent;
